import { CheckIcon, ShareIcon } from '@heroicons/react/outline'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { fileDownloader } from './fileDownload'
import Popup from './Popup'
import SocialShare from './SocialShare'
import { FormatAmount } from './FormatAmount'

const PaymentSuccess = ({ orderData, setIsSuccess }) => {
    // const { orderData } = useSelector((state) => state.orderReducer);
    const { staffInfo } = useSelector((state) => state?.authReducer);
    const [openShare, setOpenShare] = useState(false);
    const downloadInvoice = () => {
        fileDownloader(orderData?.data?.invoice, orderData?.data?.order_id);
        setIsSuccess(false);
    }
    const handleClosePopup = () => {
        setOpenShare(false);
    }
    return (
        <div className='pt-10 pb-5 text-center sm:min-w-[460px] flex flex-col gap-4'>
            <div className='px-5 text-center flex flex-col gap-2'>
                <div className='w-[83px] success-bg text-white rounded-full h-[83px] inline-flex items-center justify-center mx-auto'>
                    <CheckIcon className='w-14 h-14' />
                </div>
                <span className='text-[26px] font-semibold success-text'>Payment Success !</span>
                {/* <p className='info-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                <span className='text-[26px] font-semibold'>{FormatAmount(orderData?.data?.total_price, staffInfo?.client)}</span>
            </div>
            <hr className='opacity-30 border-[#000] rounded-xl border-dashed border-2 border-t-0 my-4' />
            <div className='px-5 flex flex-col gap-5'>
                <div>
                    {/* <span className='text-xl font-semibold'>Hello, {orderData?.data?.user?.name ?? '-'}</span> */}
                    {/* <p className='info-text w-full lg:w-[80%] mx-auto'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Donec eleifend consectetur sapien, ut commodo sem
                        iaculis sed. Cras sollicitudin metus.</p> */}
                </div>
                {/* <span className='text-base font-semibold'>Print No : 02230333500</span> */}
                <button type='button' className='success-btn text-[18px]' onClick={downloadInvoice}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-5 me-2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                    Download Invoice
                </button>
                <button type='button' className='btn-primary btn-lg text-[18px]' onClick={() => { setIsSuccess(false); setOpenShare(true); }}>
                    <ShareIcon className='size-5 me-2' />
                    Share Invoice
                </button>
            </div>
            <Popup showPopup={openShare} closePopup={handleClosePopup} callComponant={<SocialShare orderData={orderData?.data} handleClosePopup={handleClosePopup} />} closebtn={true} />
        </div>
    )
}

export default PaymentSuccess